import {
  GET_PORTFOLIO_MANAGERS_TABLE_DATA,
  GET_FC_WIDGET_DATA,
  GET_COMPARATIVE_STATS_TABLE_DATA,
  GET_ROLLING_PERFORMANCE_TABLE_DATA,
  GET_EQUITY_EXPOSURE,
  GET_STRATEGY_EXPOSURE_DATA,
  GET_GEO_EXPOSURE_DATA,
  GET_EXPOSURE_ASSET_CLASS_DATA,
  GET_MAIN_EXPOSURE_DATA,
  GET_YEAR_PERFORMANCE_EXPOSURE,
  GET_YEAR_PERFORMANCE_EXPOSURE_STDV,
  GET_SUB_STRATEGY_EXPOSURE_DATA,
  GET_TABLE_WIDGET_DATA,
  GET_INDEX_CORRELATION,
  GET_DIVERSIFICATION_RATIO_REALIZED,
  GET_DIVERSIFICATION_RATIO_BACKFILLED,
  GET_DIVERSIFICATION_BENEFIT_BACKFILLED,
  GET_DIVERSIFICATION_BENEFIT_REALIZED,
  GET_FACTOR_RESPONSE,
  GET_DISTRIBUTION_MONTHLY_RETURNS,
  GET_ROLLING_PROFITABLE,
  GET_DRAWDOWN_HISTORY,
  GET_STRATEGY_ATTRIBUTION_DATA,
  GET_LONG_SHORT_ATTRIBUTION_DATA,
  GET_HOLDING_LONG_SHORT_EXPOSURE_DATA,
  GET_HOLDING_SHORT_ATTRIBUTION_DATA,
  GET_HOLDING_LONG_ATTRIBUTION_DATA,
  GET_PORTFOLIO_STRATEGY_RISK_DATA,
  GET_PORTFOLIO_FUND_RISK_DATA,
  GET_HOLDING_EXPOSURE_MARKET_CAP_DATA,
  GET_HOLDING_GEO_EXPOSURE_DATA,
  GET_HOLDING_SECTOR_EXPOSURE_DATA,
  GET_HOLDING_COMPANY_OVERVIEW_DATA,
  GET_HOLDING_DETAILS_TABLE_DATA,
  GET_COMPARATIVE_STATS_LONG_PERFORMANCE_TABLE_DATA,
  GET_COMPARATIVE_STATS_SHORT_PERFORMANCE_TABLE_DATA,
  GET_MONTHLY_LONG_PERFORMANCE_TABLE_DATA,
  GET_MONTHLY_SHORT_PERFORMANCE_TABLE_DATA,
  GET_DOCUMENTS_ACCESS_BUTTONS,
  GET_NOTES_PREVIEW,
  GET_HOLDING_ASSET_CLASS_ATTRIBUTION,
  GET_MANAGER_PERFORMANCE,
  GET_PERFORMANCE_QUARTILES,
  GET_GENERIC_CHART_WIDGET_DATA,
  GET_ANNUAL_STACKED_COLUMN_CHARTS,
  GET_HOLDING_INVESTOR_PERFORMANCE_TABLE_DATA,
  GET_TF_TOP_POSITIONS,
  GET_TF_NEW_POSITIONS,
  GET_TF_EXISTING_POSITIONS,
  GET_TF_INCREASED_POSITIONS,
  GET_TF_DECREASED_POSITIONS,
  GET_TF_SECTOR_EXPOSURE_COLUMN,
  GET_TF_MARKET_CAP_EXPOSURE,
  GET_TF_LIQUIDITY_EXPOSURE,
  GET_TF_OVERLAP_COUNT,
  GET_TF_OVERLAP_PERCENT,
  GET_TF_SECTOR_EXPOSURE_PIE,
  GET_TABLE_B_WIDGET_DATA,
  GET_CLUSTER_DIAGRAM_WIDGET_DATA
} from 'hooks/useApi';

const endpoints = {
  0: GET_CLUSTER_DIAGRAM_WIDGET_DATA,
  1: GET_PORTFOLIO_MANAGERS_TABLE_DATA,
  2: GET_FC_WIDGET_DATA,
  3: GET_TABLE_WIDGET_DATA,
  4: GET_STRATEGY_ATTRIBUTION_DATA,
  5: GET_STRATEGY_EXPOSURE_DATA,
  6: GET_SUB_STRATEGY_EXPOSURE_DATA,
  7: GET_TABLE_WIDGET_DATA,
  8: GET_DIVERSIFICATION_RATIO_REALIZED,
  9: GET_DIVERSIFICATION_RATIO_BACKFILLED,
  10: GET_DIVERSIFICATION_BENEFIT_REALIZED,
  11: GET_DIVERSIFICATION_BENEFIT_BACKFILLED,
  12: GET_INDEX_CORRELATION,
  13: GET_INDEX_CORRELATION,
  14: GET_INDEX_CORRELATION,
  15: GET_INDEX_CORRELATION,
  16: GET_INDEX_CORRELATION,
  17: GET_INDEX_CORRELATION,
  18: GET_INDEX_CORRELATION,
  19: GET_INDEX_CORRELATION,
  20: GET_INDEX_CORRELATION,
  21: GET_INDEX_CORRELATION,
  22: GET_TABLE_B_WIDGET_DATA,
  23: GET_TABLE_WIDGET_DATA,
  24: GET_TABLE_WIDGET_DATA,
  25: GET_PORTFOLIO_STRATEGY_RISK_DATA,
  30: GET_STRATEGY_ATTRIBUTION_DATA,
  36: GET_COMPARATIVE_STATS_TABLE_DATA,
  37: GET_ROLLING_PERFORMANCE_TABLE_DATA,
  38: GET_EQUITY_EXPOSURE,
  39: GET_STRATEGY_EXPOSURE_DATA,
  40: GET_GEO_EXPOSURE_DATA,
  41: GET_EXPOSURE_ASSET_CLASS_DATA,
  43: GET_TABLE_B_WIDGET_DATA,
  45: GET_TABLE_WIDGET_DATA,
  46: GET_TABLE_WIDGET_DATA,
  47: GET_TABLE_WIDGET_DATA,
  48: GET_TABLE_WIDGET_DATA,
  49: GET_MAIN_EXPOSURE_DATA,
  50: GET_YEAR_PERFORMANCE_EXPOSURE,
  51: GET_YEAR_PERFORMANCE_EXPOSURE_STDV,
  52: GET_SUB_STRATEGY_EXPOSURE_DATA,
  54: GET_FACTOR_RESPONSE,
  55: GET_FACTOR_RESPONSE,
  56: GET_FACTOR_RESPONSE,
  57: GET_FACTOR_RESPONSE,
  58: GET_FACTOR_RESPONSE,
  59: GET_FACTOR_RESPONSE,
  60: GET_FACTOR_RESPONSE,
  61: GET_FACTOR_RESPONSE,
  62: GET_FACTOR_RESPONSE,
  63: GET_FACTOR_RESPONSE,
  67: GET_NOTES_PREVIEW,
  119: GET_PERFORMANCE_QUARTILES,
  120: GET_PERFORMANCE_QUARTILES,
  121: GET_PERFORMANCE_QUARTILES,
  122: GET_PERFORMANCE_QUARTILES,
  123: GET_PERFORMANCE_QUARTILES,
  124: GET_PERFORMANCE_QUARTILES,
  125: GET_TABLE_WIDGET_DATA,
  126: GET_TABLE_WIDGET_DATA,
  127: GET_TABLE_WIDGET_DATA,
  128: GET_TABLE_WIDGET_DATA,
  129: GET_TF_TOP_POSITIONS,
  130: GET_TF_NEW_POSITIONS,
  131: GET_TF_EXISTING_POSITIONS,
  132: GET_TF_INCREASED_POSITIONS,
  133: GET_TF_DECREASED_POSITIONS,
  134: GET_TF_SECTOR_EXPOSURE_COLUMN,
  135: GET_HOLDING_EXPOSURE_MARKET_CAP_DATA,
  136: GET_TF_LIQUIDITY_EXPOSURE,
  137: GET_TF_OVERLAP_COUNT,
  138: GET_TF_OVERLAP_PERCENT,
  139: GET_TF_SECTOR_EXPOSURE_PIE,
  140: GET_HOLDING_COMPANY_OVERVIEW_DATA,
  141: GET_ROLLING_PERFORMANCE_TABLE_DATA,
  146: GET_HOLDING_LONG_SHORT_EXPOSURE_DATA,
  147: GET_LONG_SHORT_ATTRIBUTION_DATA,
  148: GET_HOLDING_EXPOSURE_MARKET_CAP_DATA,
  149: GET_HOLDING_GEO_EXPOSURE_DATA,
  150: GET_HOLDING_SECTOR_EXPOSURE_DATA,
  151: GET_HOLDING_SECTOR_EXPOSURE_DATA,
  152: GET_HOLDING_SECTOR_EXPOSURE_DATA,
  153: GET_TABLE_WIDGET_DATA,
  154: GET_LONG_SHORT_ATTRIBUTION_DATA,
  155: GET_HOLDING_LONG_SHORT_EXPOSURE_DATA,
  156: GET_HOLDING_LONG_ATTRIBUTION_DATA,
  157: GET_HOLDING_SHORT_ATTRIBUTION_DATA,
  158: GET_MONTHLY_LONG_PERFORMANCE_TABLE_DATA,
  159: GET_COMPARATIVE_STATS_TABLE_DATA,
  160: GET_TABLE_WIDGET_DATA,
  162: GET_DISTRIBUTION_MONTHLY_RETURNS,
  163: GET_DRAWDOWN_HISTORY,
  167: GET_ROLLING_PROFITABLE,
  179: GET_HOLDING_DETAILS_TABLE_DATA,
  180: GET_MANAGER_PERFORMANCE,
  181: GET_DOCUMENTS_ACCESS_BUTTONS,
  182: GET_HOLDING_ASSET_CLASS_ATTRIBUTION,
  183: GET_EXPOSURE_ASSET_CLASS_DATA,
  186: GET_PORTFOLIO_FUND_RISK_DATA,
  187: GET_MONTHLY_SHORT_PERFORMANCE_TABLE_DATA,
  188: GET_TABLE_WIDGET_DATA,
  189: GET_COMPARATIVE_STATS_LONG_PERFORMANCE_TABLE_DATA,
  190: GET_COMPARATIVE_STATS_SHORT_PERFORMANCE_TABLE_DATA,
  191: GET_HOLDING_INVESTOR_PERFORMANCE_TABLE_DATA,
  192: GET_TABLE_WIDGET_DATA,
  193: GET_GENERIC_CHART_WIDGET_DATA,
  194: GET_ANNUAL_STACKED_COLUMN_CHARTS
};

export default endpoints;
